import { NotifyError, NotifySuccess } from "../Notify/notify";

const BASE = () => process.env.REACT_APP_API_BASE_URL + '/torknotetypes';
const authHeader = (jwtToken) => ({ Authorization: `Bearer ${jwtToken}` });
const jsonHeader = (jwtToken) => ({ "Content-Type": "application/json", ...authHeader(jwtToken) });

export const GetNoteTypes = (jwtToken, callback) => {
    fetch(BASE(), { headers: authHeader(jwtToken) })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte hämta noteringstyper."));
}

export const CreateNoteType = (noteType, jwtToken, callback) => {
    fetch(BASE(), {
        method: "POST",
        body: JSON.stringify(noteType),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Noteringstyp skapad!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte skapa noteringstyp."));
}

export const UpdateNoteType = (noteType, jwtToken, callback) => {
    fetch(BASE(), {
        method: "PUT",
        body: JSON.stringify(noteType),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Noteringstyp uppdaterad!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte uppdatera noteringstyp."));
}

export const DeleteNoteType = (id, jwtToken, callback) => {
    fetch(BASE() + '/' + id, {
        method: "DELETE",
        headers: authHeader(jwtToken)
    })
        .then(res => res.json())
        .then(() => {
            NotifySuccess("Noteringstyp borttagen!");
            callback();
        })
        .catch(() => NotifyError("Kunde inte ta bort noteringstyp."));
}
